import { useRouterState } from "@tanstack/react-router";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { useCookieConsentStore } from "@/stores/cookieConsentStore";

/**
 * Hook that tracks SPA pageviews via PostHog on every route change,
 * including the initial mount (PostHog auto-pageview is disabled).
 */
export function usePostHogPageviewTracker() {
  const posthog = usePostHog();
  const { pathname, search } = useRouterState({
    select: (s) => s.location,
  });
  const { analyticsConsent, consentStatus } = useCookieConsentStore(
    useShallow((state) => ({
      analyticsConsent: state.preferences.analytics,
      consentStatus: state.status,
    })),
  );

  useEffect(() => {
    if (!posthog || consentStatus !== "accepted" || !analyticsConsent) {
      return;
    }

    posthog.capture("$pageview");
  }, [pathname, search, posthog, analyticsConsent, consentStatus]);
}

export function PostHogPageviewTracker() {
  usePostHogPageviewTracker();
  return null;
}
